import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { RequestStatus } from '@app/constants';
import {
  IAddBoardSchema,
  IUpdateCardSchema,
  IAddDateSchema,
  IAddDescriptionSchema,
  IAddListSchema,
  IDeleteCardSchema,
  IGetCardDetailSchema,
  IMoveCardSchema,
  ITaskBoard,
  ITaskBoardState,
  IAddReaction,
} from './types';
import { IRequestFailed } from '@app/types';
const initialState: ITaskBoardState = {
  taskBoard: {},
  addTaskBoard: {},
  toggleLabel: {},
  boardDetails: {},
  addList: {},
  addCard: {},
  updateCardTitle: {},
  addAttachment: {},
  addDate: {},
  cardDetailsById: {},
  moveCard: {},
  addCardMember: {},
  addCoverImage: {},
  deleteCard: {},
  deleteList: {},
  addDescription: {},
  searchMember: {},
  searchBoard: {},
  deleteAttachment: {},
  getBackground: {},
  updateBoard: {},
  addMember: {},
  deleteMember: {},
  updateDate: {},
  deleteMemberFromCard: {},
  updateMember: {},
  addLabel: {},
  deleteLabel: {},
  updateLabel: {},
  getLabels: {},
  getComments: {},
  addComments: {},
  deleteComment: {},
  deleteDate: {},
  updateComment: {},
  replyComment: {},
  addCheckList: {},
  deleteCheckList: {},
  checklist: {},
  updateChecklist: {},
  addCheckListItem: {},
  checkListItem: {},
  updateItemStatus: {},
  deleteCheckListItem: {},
  transaction: {},
  board: null,
  status: 'idle',
  addReaction: {},
};
const slice = createSlice({
  name: 'taskBoard',
  initialState,
  reducers: {
    getComments(state, action: PayloadAction<{ cardId: number | string | undefined }>) {
      state.getComments.status = RequestStatus.RUNNING;
    },
    getCommentsSuccess(state, action: PayloadAction<any>) {
      state.getComments.status = RequestStatus.SUCCESS;
      state.getComments.data = action.payload;
    },
    getCommentsFailed(state, action: PayloadAction<IRequestFailed>) {
      state.getComments.status = RequestStatus.ERROR;
      state.getComments.error = action.payload;
    },
    //
    addComments(state, action: PayloadAction<any>) {
      state.addComments.status = RequestStatus.RUNNING;
    },
    addCommentsSuccess(state, action) {
      state.addComments.status = RequestStatus.SUCCESS;
      state.addComments.data = action.payload;
    },
    addCommentsFailed(state, action: PayloadAction<IRequestFailed>) {
      state.addComments.status = RequestStatus.ERROR;
      state.addComments.error = action.payload;
    },
    //
    deleteCommentByID(state, action: PayloadAction<{ commentId: number | string | undefined }>) {
      state.deleteComment.status = RequestStatus.RUNNING;
    },
    deleteCommentByIDSuccess(
      state,
      action: PayloadAction<ITaskBoardState['deleteComment']['data']>
    ) {
      state.deleteComment.status = RequestStatus.SUCCESS;
      state.deleteComment.data = action.payload;
    },
    deleteCommentByIDFailed(state, action: PayloadAction<IRequestFailed>) {
      state.deleteComment.status = RequestStatus.ERROR;
      state.deleteComment.error = action.payload;
    },
    //
    updateCommentByID(
      state,
      action: PayloadAction<{
        commentId: number | string | undefined;
        mentionedUserIds: number[];
        name: string;
      }>
    ) {
      state.updateComment.status = RequestStatus.RUNNING;
    },
    updateCommentByIDSuccess(
      state,
      action: PayloadAction<ITaskBoardState['updateComment']['data']>
    ) {
      state.updateComment.status = RequestStatus.SUCCESS;
      state.updateComment.data = action.payload;
    },
    updateCommentByIDFailed(state, action: PayloadAction<IRequestFailed>) {
      state.updateComment.status = RequestStatus.ERROR;
      state.updateComment.error = action.payload;
    },
    //
    replyComment(state, action: PayloadAction<any>) {
      state.replyComment.status = RequestStatus.RUNNING;
    },
    replyCommentSuccess(state, action) {
      state.replyComment.status = RequestStatus.SUCCESS;
      state.replyComment.data = action.payload;
    },
    replyCommentFailed(state, action: PayloadAction<IRequestFailed>) {
      state.replyComment.status = RequestStatus.ERROR;
      state.replyComment.error = action.payload;
    },
    //
    getTaskBoard(state, action: PayloadAction<{ userId: number | undefined }>) {
      state.taskBoard.status = RequestStatus.RUNNING;
    },
    getTaskBoardSuccess(state, action: PayloadAction<ITaskBoard>) {
      state.taskBoard.status = RequestStatus.SUCCESS;
      state.taskBoard.data = action.payload;
    },
    getTaskBoardFailed(state, action: PayloadAction<IRequestFailed>) {
      state.taskBoard.status = RequestStatus.ERROR;
      state.taskBoard.error = action.payload;
    },
    //
    addTaskBoard(state, action: PayloadAction<any>) {
      state.addTaskBoard.status = RequestStatus.RUNNING;
    },
    addTaskBoardSuccess(state, action) {
      state.addTaskBoard.status = RequestStatus.SUCCESS;
      state.addTaskBoard.data = action.payload;
    },
    addTaskBoardFailed(state, action: PayloadAction<IRequestFailed>) {
      state.addTaskBoard.status = RequestStatus.ERROR;
      state.addTaskBoard.error = action.payload;
    },
    //
    getBoardDetails(state, action: PayloadAction<number>) {
      state.boardDetails.status = RequestStatus.RUNNING;
    },
    getBoardDetailsSuccess(state, action: PayloadAction<ITaskBoardState['boardDetails']['data']>) {
      state.boardDetails.status = RequestStatus.SUCCESS;
      state.boardDetails.data = action.payload;
    },
    getBoardDetailsFailed(state, action: PayloadAction<IRequestFailed>) {
      state.boardDetails.status = RequestStatus.ERROR;
      state.boardDetails.error = action.payload;
    },
    //
    addList(state, action: PayloadAction<IAddListSchema>) {
      state.addList.status = RequestStatus.RUNNING;
    },
    addListSuccess(state, action) {
      state.addList.status = RequestStatus.SUCCESS;
      state.addList.data = action.payload;
    },
    addListFailed(state, action: PayloadAction<IRequestFailed>) {
      state.addList.status = RequestStatus.ERROR;
      state.addList.error = action.payload;
    },
    //
    addCard(state, action: PayloadAction<IAddBoardSchema>) {
      state.addCard.status = RequestStatus.RUNNING;
    },
    addCardSuccess(state, action) {
      state.addCard.status = RequestStatus.SUCCESS;
      state.addCard.data = action.payload;
    },
    addCardFailed(state, action: PayloadAction<IRequestFailed>) {
      state.addCard.status = RequestStatus.ERROR;
      state.addCard.error = action.payload;
    },
    //
    updateCardTitle(state, action: PayloadAction<IUpdateCardSchema>) {
      state.updateCardTitle.status = RequestStatus.RUNNING;
    },
    updateCardTitleSuccess(state, action) {
      state.updateCardTitle.status = RequestStatus.SUCCESS;
      state.updateCardTitle.data = action.payload;
    },
    updateCardTitleFailed(state, action: PayloadAction<IRequestFailed>) {
      state.updateCardTitle.status = RequestStatus.ERROR;
      state.updateCardTitle.error = action.payload;
    },
    //
    addDate(state, action: PayloadAction<IAddDateSchema>) {
      state.addDate.status = RequestStatus.RUNNING;
    },
    addDateSuccess(state, action) {
      state.addDate.status = RequestStatus.SUCCESS;
      state.addDate.data = action.payload;
    },
    addDateFailed(state, action: PayloadAction<IRequestFailed>) {
      state.addDate.status = RequestStatus.ERROR;
      state.addDate.error = action.payload;
    },
    deleteDate(state, action: PayloadAction<{ dateId: string | number }>) {
      state.deleteDate.status = RequestStatus.RUNNING;
      state.deleteDate.data = action.payload;
    },
    deleteDateSuccess(state, action) {
      state.deleteDate.status = RequestStatus.SUCCESS;
      state.deleteDate.data = action.payload;
    },
    deleteDateFailed(state, action: PayloadAction<IRequestFailed>) {
      state.deleteDate.status = RequestStatus.ERROR;
      state.deleteDate.error = action.payload;
    },
    //
    addAttachment(state, action: PayloadAction<{ attachments: any; cardId: string | undefined }>) {
      state.addAttachment.status = RequestStatus.RUNNING;
    },
    addAttachmentSuccess(state, action) {
      state.addAttachment.status = RequestStatus.SUCCESS;
      state.addAttachment.data = action.payload;
    },
    addAttachmentFailed(state, action: PayloadAction<IRequestFailed>) {
      state.addAttachment.status = RequestStatus.ERROR;
      state.addAttachment.error = action.payload;
    },
    //
    getCardDetailsByID(state, action: PayloadAction<IGetCardDetailSchema>) {
      state.cardDetailsById.status = RequestStatus.RUNNING;
    },
    getCardDetailsByIDSuccess(
      state,
      action: PayloadAction<ITaskBoardState['cardDetailsById']['data']>
    ) {
      state.cardDetailsById.status = RequestStatus.SUCCESS;
      state.cardDetailsById.data = action.payload;
    },
    getCardDetailsByIDFailed(state, action: PayloadAction<IRequestFailed>) {
      state.cardDetailsById.status = RequestStatus.ERROR;
      state.cardDetailsById.error = action.payload;
    },
    //
    moveCard(state, action: PayloadAction<IMoveCardSchema>) {
      state.moveCard.status = RequestStatus.RUNNING;
    },
    moveCardSuccess(state, action) {
      state.moveCard.status = RequestStatus.SUCCESS;
      state.moveCard.data = action.payload;
    },
    moveCardFailed(state, action: PayloadAction<IRequestFailed>) {
      state.moveCard.status = RequestStatus.ERROR;
      state.moveCard.error = action.payload;
    },
    //
    addCardMember(state, action: PayloadAction<{ cardId: number; membersUserIds: number[] }>) {
      state.addCardMember.status = RequestStatus.RUNNING;
    },
    addCardMemberSuccess(state, action) {
      state.addCardMember.status = RequestStatus.SUCCESS;
      state.addCardMember.data = action.payload;
    },
    addCardMemberFailed(state, action: PayloadAction<IRequestFailed>) {
      state.addCardMember.status = RequestStatus.ERROR;
      state.addCardMember.error = action.payload;
    },
    //
    addCoverImage(state, action: PayloadAction<{ attachmentId: number; isCoverImage: boolean }>) {
      state.addCoverImage.status = RequestStatus.RUNNING;
    },
    addCoverImageSuccess(state, action: PayloadAction<ITaskBoardState['addCoverImage']['data']>) {
      state.addCoverImage.status = RequestStatus.SUCCESS;
      state.addCoverImage.data = action.payload;
    },
    addCoverImageFailed(state, action: PayloadAction<IRequestFailed>) {
      state.addCoverImage.status = RequestStatus.ERROR;
      state.addCoverImage.error = action.payload;
    },
    //
    deleteCardByID(state, action: PayloadAction<IDeleteCardSchema>) {
      state.deleteCard.status = RequestStatus.RUNNING;
    },
    deleteCardByIDSuccess(
      state,
      action: PayloadAction<ITaskBoardState['cardDetailsById']['data']>
    ) {
      state.deleteCard.status = RequestStatus.SUCCESS;
      state.deleteCard.data = action.payload;
    },
    deleteCardsByIDFailed(state, action: PayloadAction<IRequestFailed>) {
      state.deleteCard.status = RequestStatus.ERROR;
      state.deleteCard.error = action.payload;
    },
    //
    deleteListByID(state, action: PayloadAction<{ listId: string }>) {
      state.deleteList.status = RequestStatus.RUNNING;
    },
    deleteListByIDSuccess(state, action: PayloadAction<ITaskBoardState['deleteList']['data']>) {
      state.deleteList.status = RequestStatus.SUCCESS;
      state.deleteList.data = action.payload;
    },
    deleteListByIDFailed(state, action: PayloadAction<IRequestFailed>) {
      state.deleteList.status = RequestStatus.ERROR;
      state.deleteList.error = action.payload;
    },
    //
    addDescription(state, action: PayloadAction<IAddDescriptionSchema>) {
      state.addDescription.status = RequestStatus.RUNNING;
    },
    addDescriptionSuccess(state, action: PayloadAction<ITaskBoardState['addDescription']['data']>) {
      state.addDescription.status = RequestStatus.SUCCESS;
      state.addDescription.data = action.payload;
    },
    addDescriptionFailed(state, action: PayloadAction<IRequestFailed>) {
      state.addDescription.status = RequestStatus.ERROR;
      state.addDescription.error = action.payload;
    },
    //
    getSearchMember(state, action: PayloadAction<any>) {
      state.searchMember.status = RequestStatus.RUNNING;
    },
    getSearchMemberSuccess(state, action: PayloadAction<ITaskBoardState['taskBoard']['data']>) {
      state.searchMember.status = RequestStatus.SUCCESS;
      state.searchMember.data = action.payload;
    },
    getSearchMemberFailed(state, action: PayloadAction<IRequestFailed>) {
      state.searchMember.status = RequestStatus.ERROR;
      state.searchMember.error = action.payload;
    },
    //
    getSearchBoard(state, action: PayloadAction<any>) {
      state.searchBoard.status = RequestStatus.RUNNING;
    },
    getSearchBoardSuccess(state, action: PayloadAction<ITaskBoardState['taskBoard']['data']>) {
      state.searchBoard.status = RequestStatus.SUCCESS;
      state.searchBoard.data = action.payload;
    },
    getSearchBoardFailed(state, action: PayloadAction<IRequestFailed>) {
      state.searchBoard.status = RequestStatus.ERROR;
      state.searchBoard.error = action.payload;
    },
    //
    deleteAttacmentByID(state, action: PayloadAction<{ attachmentId: number }>) {
      state.deleteAttachment.status = RequestStatus.RUNNING;
    },
    deleteAttacmentByIDSuccess(
      state,
      action: PayloadAction<ITaskBoardState['deleteList']['data']>
    ) {
      state.deleteAttachment.status = RequestStatus.SUCCESS;
      state.deleteAttachment.data = action.payload;
    },
    deleteAttacmentByIDFailed(state, action: PayloadAction<IRequestFailed>) {
      state.deleteAttachment.status = RequestStatus.ERROR;
      state.deleteAttachment.error = action.payload;
    },
    //
    getBackground(state) {
      state.getBackground.status = RequestStatus.RUNNING;
    },
    getBackgroundSuccess(state, action: PayloadAction<ITaskBoardState['taskBoard']['data']>) {
      state.getBackground.status = RequestStatus.SUCCESS;
      state.getBackground.data = action.payload;
    },
    getBackgroundFailed(state, action: PayloadAction<IRequestFailed>) {
      state.getBackground.status = RequestStatus.ERROR;
      state.getBackground.error = action.payload;
    },
    //
    updateBoard(state, action: PayloadAction<any>) {
      state.updateBoard.status = RequestStatus.RUNNING;
    },
    updateBoardSuccess(state, action: PayloadAction<ITaskBoardState>) {
      state.updateBoard.status = RequestStatus.SUCCESS;
      state.updateBoard.data = action.payload;
    },
    updateBoardFailed(state, action: PayloadAction<IRequestFailed>) {
      state.updateBoard.status = RequestStatus.ERROR;
      state.updateBoard.error = action.payload;
    },
    //
    addMember(state, action: PayloadAction<any>) {
      state.addMember.status = RequestStatus.RUNNING;
    },
    addMemberSuccess(state, action) {
      state.addMember.status = RequestStatus.SUCCESS;
      state.addMember.data = action.payload;
    },
    addMemberFailed(state, action: PayloadAction<IRequestFailed>) {
      state.addMember.status = RequestStatus.ERROR;
      state.addMember.error = action.payload;
    },
    //
    deleteMember(state, action: PayloadAction<{ userId: number; boardId: number }>) {
      state.deleteMember.status = RequestStatus.RUNNING;
    },
    deleteMemberSuccess(state, action: PayloadAction<ITaskBoardState['deleteMember']['data']>) {
      state.deleteMember.status = RequestStatus.SUCCESS;
      state.deleteMember.data = action.payload;
    },
    deleteMemberFailed(state, action: PayloadAction<IRequestFailed>) {
      state.deleteMember.status = RequestStatus.ERROR;
      state.deleteMember.error = action.payload;
    },
    //
    updateDate(state, action: PayloadAction<any>) {
      state.updateDate.status = RequestStatus.RUNNING;
    },
    updateDateSuccess(state, action: PayloadAction<ITaskBoardState>) {
      state.updateDate.status = RequestStatus.SUCCESS;
      state.updateDate.data = action.payload;
    },
    updateDateFailed(state, action: PayloadAction<IRequestFailed>) {
      state.updateDate.status = RequestStatus.ERROR;
      state.updateDate.error = action.payload;
    },
    //

    deleteMemberFromCard(state, action: PayloadAction<{ userId: number; cardId: number }>) {
      state.deleteMemberFromCard.status = RequestStatus.RUNNING;
    },
    deleteMemberFromCardSuccess(
      state,
      action: PayloadAction<ITaskBoardState['deleteMemberFromCard']['data']>
    ) {
      state.deleteMemberFromCard.status = RequestStatus.SUCCESS;
      state.deleteMemberFromCard.data = action.payload;
    },
    deleteMemberFromCardFailed(state, action: PayloadAction<IRequestFailed>) {
      state.deleteMemberFromCard.status = RequestStatus.ERROR;
      state.deleteMemberFromCard.error = action.payload;
    },
    //
    updateMember(state, action: PayloadAction<any>) {
      state.updateMember.status = RequestStatus.RUNNING;
    },
    updateMemberSuccess(state, action: PayloadAction<ITaskBoardState>) {
      state.updateMember.status = RequestStatus.SUCCESS;
      state.updateMember.data = action.payload;
    },
    updateMemberFailed(state, action: PayloadAction<IRequestFailed>) {
      state.updateMember.status = RequestStatus.ERROR;
      state.updateMember.error = action.payload;
    },
    //
    addLabel(state, action: PayloadAction<any>) {
      state.addLabel.status = RequestStatus.RUNNING;
    },
    addLabelSuccess(state, action) {
      state.addLabel.status = RequestStatus.SUCCESS;
      state.addLabel.data = action.payload;
    },
    addLabelFailed(state, action: PayloadAction<IRequestFailed>) {
      state.addLabel.status = RequestStatus.ERROR;
      state.addLabel.error = action.payload;
    },
    //
    toggleLabel(state, action: PayloadAction<{ labelId: number; cardId: number }>) {
      state.toggleLabel.status = RequestStatus.RUNNING;
      state.toggleLabel.data = action.payload;
    },
    toggleLabelSuccess(state, action) {
      state.toggleLabel.status = RequestStatus.SUCCESS;
      state.toggleLabel.data = action.payload;
    },
    toggleLabelFailed(state, action: PayloadAction<IRequestFailed>) {
      state.toggleLabel.status = RequestStatus.ERROR;
      state.toggleLabel.error = action.payload;
    },
    //
    deleteLabel(state, action: PayloadAction<{ labelId: number }>) {
      state.deleteLabel.status = RequestStatus.RUNNING;
    },
    deleteLabelSuccess(state, action: PayloadAction<ITaskBoardState['deleteLabel']['data']>) {
      state.deleteLabel.status = RequestStatus.SUCCESS;
      state.deleteLabel.data = action.payload;
    },
    deleteLabelFailed(state, action: PayloadAction<IRequestFailed>) {
      state.deleteLabel.status = RequestStatus.ERROR;
      state.deleteLabel.error = action.payload;
    },
    //
    updateLabel(state, action: PayloadAction<any>) {
      state.updateLabel.status = RequestStatus.RUNNING;
    },
    updateLabelSuccess(state, action: PayloadAction<ITaskBoardState>) {
      state.updateLabel.status = RequestStatus.SUCCESS;
      state.updateLabel.data = action.payload;
    },
    updateLabelFailed(state, action: PayloadAction<IRequestFailed>) {
      state.updateLabel.status = RequestStatus.ERROR;
      state.updateLabel.error = action.payload;
    },
    //
    getLabels(state, action: PayloadAction<any>) {
      state.getLabels.status = RequestStatus.RUNNING;
    },
    getLabelsSuccess(state, action: PayloadAction<ITaskBoardState['taskBoard']['data']>) {
      state.getLabels.status = RequestStatus.SUCCESS;
      state.getLabels.data = action.payload;
    },
    getLabelsFailed(state, action: PayloadAction<IRequestFailed>) {
      state.getLabels.status = RequestStatus.ERROR;
      state.getLabels.error = action.payload;
    },
    //
    addCheckList(
      state,
      action: PayloadAction<{ text: string; isCompleted: boolean; cardId: number }>
    ) {
      state.addCheckList.status = RequestStatus.RUNNING;
    },
    addCheckListSuccess(state, action) {
      state.addCheckList.status = RequestStatus.SUCCESS;
      state.addCheckList.data = action.payload;
    },
    addCheckListFailed(state, action: PayloadAction<IRequestFailed>) {
      state.addCheckList.status = RequestStatus.ERROR;
      state.addCheckList.error = action.payload;
    },
    //
    deleteCheckList(state, action: PayloadAction<{ checkListId: number }>) {
      state.deleteCheckList.status = RequestStatus.RUNNING;
    },
    deleteCheckListSuccess(state, action) {
      state.deleteCheckList.status = RequestStatus.SUCCESS;
      state.deleteCheckList.data = action.payload;
    },
    deleteCheckListFailed(state, action: PayloadAction<IRequestFailed>) {
      state.deleteCheckList.status = RequestStatus.ERROR;
      state.deleteCheckList.error = action.payload;
    },
    //
    getChecklist(state, action: PayloadAction<{ cardId: number }>) {
      state.checklist.status = RequestStatus.RUNNING;
    },
    getChecklistSuccess(state, action: PayloadAction<ITaskBoardState['taskBoard']['data']>) {
      state.checklist.status = RequestStatus.SUCCESS;
      state.checklist.data = action.payload;
    },
    getChecklistFailed(state, action: PayloadAction<IRequestFailed>) {
      state.checklist.status = RequestStatus.ERROR;
      state.checklist.error = action.payload;
    },
    //
    updateCheckList(
      state,
      action: PayloadAction<{ checkListId: number; text: string; isCompleted: boolean }>
    ) {
      state.updateChecklist.status = RequestStatus.RUNNING;
    },
    updateCheckListSuccess(state, action: PayloadAction<ITaskBoardState['taskBoard']['data']>) {
      state.updateChecklist.status = RequestStatus.SUCCESS;
      state.updateChecklist.data = action.payload;
    },
    updateCheckListFailed(state, action: PayloadAction<IRequestFailed>) {
      state.updateChecklist.status = RequestStatus.ERROR;
      state.updateChecklist.error = action.payload;
    },
    //
    addCheckListItem(
      state,
      action: PayloadAction<{ checkListId: number; title: string; isChecked: boolean }>
    ) {
      state.addCheckListItem.status = RequestStatus.RUNNING;
    },
    addCheckListItemSuccess(state, action: PayloadAction<ITaskBoardState['taskBoard']['data']>) {
      state.addCheckListItem.status = RequestStatus.SUCCESS;
      state.addCheckListItem.data = action.payload;
    },
    addCheckListItemFailed(state, action: PayloadAction<IRequestFailed>) {
      state.addCheckListItem.status = RequestStatus.ERROR;
      state.addCheckListItem.error = action.payload;
    },
    //
    getCheckListItem(state, action: PayloadAction<{ checklistId: number }>) {
      state.checkListItem.status = RequestStatus.RUNNING;
    },
    getCheckListItemSuccess(
      state,
      action: PayloadAction<ITaskBoardState['checkListItem']['data']>
    ) {
      state.checkListItem.status = RequestStatus.SUCCESS;
      state.checkListItem.data = action.payload;
    },
    getCheckListItemFailed(state, action: PayloadAction<IRequestFailed>) {
      state.checkListItem.status = RequestStatus.ERROR;
      state.checkListItem.error = action.payload;
    },
    //
    updateItemStatus(
      state,
      action: PayloadAction<{ itemId: number; title: string; isChecked: boolean }>
    ) {
      state.updateItemStatus.status = RequestStatus.RUNNING;
    },
    updateItemStatusSuccess(
      state,
      action: PayloadAction<ITaskBoardState['updateItemStatus']['data']>
    ) {
      state.updateItemStatus.status = RequestStatus.SUCCESS;
      state.updateItemStatus.data = action.payload;
    },
    updateItemStatusFailed(state, action: PayloadAction<IRequestFailed>) {
      state.updateItemStatus.status = RequestStatus.ERROR;
      state.updateItemStatus.error = action.payload;
    },
    //
    deleteCheckListItem(state, action: PayloadAction<{ itemId: number }>) {
      state.deleteCheckListItem.status = RequestStatus.RUNNING;
    },
    deleteCheckListItemSuccess(state, action) {
      state.deleteCheckListItem.status = RequestStatus.SUCCESS;
      state.deleteCheckListItem.data = action.payload;
    },
    deleteCheckListItemFailed(state, action: PayloadAction<IRequestFailed>) {
      state.deleteCheckListItem.status = RequestStatus.ERROR;
      state.deleteCheckListItem.error = action.payload;
    },
    //
    setBoard: (state, action: PayloadAction<any>) => {
      state.board = action.payload;
    },
    updateBoardSocketStatus: (state, action: PayloadAction<any>) => {
      state.board = action.payload;
    },
    setStatus: (state, action: PayloadAction<ITaskBoardState['status']>) => {
      state.status = action.payload;
    },
    //
    getTransaction(state, action: PayloadAction<{ cardId: number | string }>) {
      state.transaction.status = RequestStatus.RUNNING;
    },
    getTransactionSuccess(state, action: PayloadAction<ITaskBoardState['taskBoard']['data']>) {
      state.transaction.status = RequestStatus.SUCCESS;
      state.transaction.data = action.payload;
    },
    getTransactionFailed(state, action: PayloadAction<IRequestFailed>) {
      state.transaction.status = RequestStatus.ERROR;
      state.transaction.error = action.payload;
    },
    //
    addReaction(state, action: PayloadAction<IAddReaction>) {
      state.addReaction.status = RequestStatus.RUNNING;
    },
    addReactionSuccess(state, action) {
      state.addReaction.status = RequestStatus.SUCCESS;
      state.addReaction.data = action.payload;
    },
    addReactionFailed(state, action: PayloadAction<IRequestFailed>) {
      state.addReaction.status = RequestStatus.ERROR;
      state.addReaction.error = action.payload;
    },
  },
});
export default slice.reducer;
export const {
  getTransaction,
  getTransactionSuccess,
  getTransactionFailed,
  replyComment,
  replyCommentSuccess,
  replyCommentFailed,
  updateCommentByID,
  updateCommentByIDSuccess,
  updateCommentByIDFailed,
  getComments,
  getCommentsSuccess,
  getCommentsFailed,
  addComments,
  addCommentsSuccess,
  addCommentsFailed,
  deleteCommentByID,
  deleteCommentByIDSuccess,
  deleteCommentByIDFailed,
  getTaskBoard,
  getTaskBoardSuccess,
  getTaskBoardFailed,
  addTaskBoard,
  addTaskBoardSuccess,
  addTaskBoardFailed,
  getBoardDetails,
  getBoardDetailsSuccess,
  getBoardDetailsFailed,
  addList,
  addListSuccess,
  addListFailed,
  addCard,
  addCardSuccess,
  addCardFailed,
  updateCardTitle,
  updateCardTitleSuccess,
  updateCardTitleFailed,
  addAttachment,
  addAttachmentFailed,
  addAttachmentSuccess,
  addDate,
  addDateSuccess,
  addDateFailed,
  getCardDetailsByID,
  getCardDetailsByIDSuccess,
  getCardDetailsByIDFailed,
  moveCard,
  moveCardSuccess,
  moveCardFailed,
  addCardMember,
  addCardMemberSuccess,
  addCardMemberFailed,
  addCoverImage,
  addCoverImageSuccess,
  addCoverImageFailed,
  deleteCardByID,
  deleteCardByIDSuccess,
  deleteCardsByIDFailed,
  deleteListByID,
  deleteListByIDSuccess,
  deleteListByIDFailed,
  addDescription,
  addDescriptionSuccess,
  addDescriptionFailed,
  getSearchMember,
  getSearchMemberFailed,
  getSearchMemberSuccess,
  getSearchBoard,
  getSearchBoardFailed,
  getSearchBoardSuccess,
  deleteAttacmentByID,
  deleteAttacmentByIDSuccess,
  deleteAttacmentByIDFailed,
  getBackground,
  getBackgroundFailed,
  getBackgroundSuccess,
  updateBoard,
  updateBoardFailed,
  updateBoardSuccess,
  addMember,
  addMemberFailed,
  addMemberSuccess,
  deleteMember,
  deleteMemberFailed,
  deleteMemberSuccess,
  updateDate,
  updateDateFailed,
  updateDateSuccess,
  deleteMemberFromCard,
  deleteMemberFromCardFailed,
  deleteMemberFromCardSuccess,
  updateMember,
  updateMemberFailed,
  updateMemberSuccess,
  addLabel,
  addLabelSuccess,
  addLabelFailed,
  deleteLabel,
  deleteLabelFailed,
  deleteLabelSuccess,
  deleteDate,
  deleteDateFailed,
  deleteDateSuccess,
  updateLabel,
  updateLabelSuccess,
  updateLabelFailed,
  getLabels,
  getLabelsFailed,
  getLabelsSuccess,
  toggleLabel,
  toggleLabelSuccess,
  toggleLabelFailed,
  addCheckList,
  addCheckListFailed,
  addCheckListSuccess,
  deleteCheckList,
  deleteCheckListSuccess,
  deleteCheckListFailed,
  getChecklist,
  getChecklistSuccess,
  getChecklistFailed,
  updateCheckList,
  updateCheckListSuccess,
  updateCheckListFailed,
  addCheckListItem,
  addCheckListItemFailed,
  addCheckListItemSuccess,
  getCheckListItem,
  getCheckListItemFailed,
  getCheckListItemSuccess,
  updateItemStatus,
  updateItemStatusFailed,
  updateItemStatusSuccess,
  deleteCheckListItem,
  deleteCheckListItemFailed,
  deleteCheckListItemSuccess,
  setBoard,
  setStatus,
  updateBoardSocketStatus,
  addReaction,
  addReactionFailed,
  addReactionSuccess,
} = slice.actions;
